import { type JSX } from 'react/jsx-runtime';
import { createRender, type HydrationResult } from './types';

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(() => null);

export default render;
